import React, { useState } from 'react';
import { Button, TextField, Box, Typography, Container, Paper, CircularProgress, Alert } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import FetchService from '../../services/FetchService';
import endpoints from '../../environment/endpoints';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const fetchService = new FetchService();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    const res = await fetchService.post(endpoints.register, { email, password });
    if (res.success && res.data?.status === 'Success') {
      setSuccess('Registration successful! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } else {
      setError(res.data?.message || res.errors || 'Registration failed.');
    }
    setIsLoading(false);
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h4" gutterBottom fontWeight="bold" color="secondary">
          Create an Account
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
          Join Mash Rank today!
        </Typography>

        {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{success}</Alert>}

        <Box component="form" onSubmit={handleRegister} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            helperText="Password must be at least 6 characters long."
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            disabled={isLoading}
            sx={{ mt: 3, mb: 2, padding: 1.5, fontSize: '1.1rem' }}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Register'}
          </Button>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography variant="body2">
              Already have an account?{' '}
              <Link to="/login" style={{ color: '#FF3900', textDecoration: 'none', fontWeight: 'bold' }}>
                Log In
              </Link>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
